module.exports = __webpack_public_path__ + "img/1.bcc0408f.png";